// Picks the right API base:
// - On real hosts (prod/staging): force same-origin "/api"
// - On local dev: use REACT_APP_DEV (e.g. "http://localhost:3001") with no "/api" needed

const isBrowser = typeof window !== "undefined";

export const PRODUCTION_APP_HOSTS = new Set([
  "inzeloop.com",
  "www.inzeloop.com",
  "inzeloop.co",
  "www.inzeloop.co",
  "inzeloop.fr",
  "www.inzeloop.fr",
]);

const SAME_ORIGIN_HOSTS = new Set([
  ...PRODUCTION_APP_HOSTS,
  "inzeloop.ai",
  "www.inzeloop.ai",
  "staging.inzeloop.ai",
  "www.staging.inzeloop.ai",
]);

function normalize(base: string) {
  return base.replace(/\/+$/, "");
}

function pickApiBase(): string {
  const env = process.env.REACT_APP_ENV ?? "dev";

  if (isBrowser) {
    const hostname = window.location.hostname;
    if (SAME_ORIGIN_HOSTS.has(hostname)) {
      return "/api";
    }
  }

  const map: Record<string, string | undefined> = {
    dev: process.env.REACT_APP_DEV,
    staging: process.env.REACT_APP_STAGING,
    prod: process.env.REACT_APP_PROD,
  };

  const raw = (map[env] || "").trim() || "http://localhost:3001";

  try {
    const u = new URL(raw);
    return normalize(u.toString());
  } catch {
    return normalize(raw);
  }
}

export const API_BASE = pickApiBase();
